import { STORAGE_KEY } from "@constants";
import { safeSessionRemoveItem } from "@utils/storage";
import { useEffect } from "react";

const CRASH_SESSION_CLEANUP_DELAY_MS = 1000;
const DEFAULT_CRASH_CLEANUP_KEYS = [
  STORAGE_KEY.PAGE_CRASH_AUTO_RELOAD_COUNT,
  STORAGE_KEY.PAGE_CRASH_SENTRY_EVENT_ID,
] as const;

interface UseCrashSessionCleanupOptions {
  delayMs?: number;
  enabled?: boolean;
  keys?: readonly string[];
}

const useCrashSessionCleanup = (options?: UseCrashSessionCleanupOptions): void => {
  const delayMs = options?.delayMs ?? CRASH_SESSION_CLEANUP_DELAY_MS;
  const enabled = options?.enabled ?? true;
  const keys = options?.keys ?? DEFAULT_CRASH_CLEANUP_KEYS;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      keys.forEach((key) => safeSessionRemoveItem(key));
    }, delayMs);

    return () => window.clearTimeout(timeoutId);
  }, [delayMs, enabled, keys]);
};

export default useCrashSessionCleanup;
